import { useEffect } from 'react';

const useVersion = (currentVersion: string) => {
  const versionKey = 'versionId';

  useEffect(() => {
    const savedVersion = localStorage.getItem(versionKey);

    if (currentVersion !== savedVersion) {
      localStorage.clear();
      localStorage.setItem(versionKey, currentVersion);
    }
  }, []);
};

export default useVersion;
